import { FormFieldNotificationTemplateAssociation } from './form-field-notification-template-association.model';

export class ContactsGridNotificationTemplateAssociations {
    public constructor(public contactsGridFormFieldId: number, public formFieldNotificationTemplateAssociations: FormFieldNotificationTemplateAssociation[])
    {
    }
}
